export default __webpack_public_path__ + "static/cinnamon_small_square-a93bf09a1a8564351978b9f6057f893e.jpg";